import "./ResourceDDLDataTableForSlipsStyle.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { Box, Grid, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

import ArchiveIcon from "@mui/icons-material/Archive";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { EnhancedButtonPrimeReactSeverity } from "../../common/Common";
import { IAppState } from "../../store/reducers";
import { InputText } from "primereact/inputtext";
import { RequestParams } from "@websential/cosmic-v20";
import { useSelector } from "react-redux";

export interface IResourceDDLDataTableForSlips {
	rows: any;
	columns?: any;
	headerField?: any;
	onResourceSlipSelectionChangeHandler?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	onRowArchiveClicked?: () => void;
	isLoading?: any;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	rowsPerPageOptions?: number[];
	tableScrollHeight?: string;
	selectedResourceSlipList?: any;
	selectedResourceSlip?: any;
	selectedEmployee?: any;
	showHeaderColumns?: boolean;
	showDeleteIcon?: boolean;
	showArchiveIcon?: boolean;
	selectedId?: string;
	tableContainerRef: any;
}

export const ResourceDDLDataTableForSlips: React.FC<
	IResourceDDLDataTableForSlips
> = ({
	rows,
	columns,
	onResourceSlipSelectionChangeHandler,
	onRowEditClicked,
	onRowArchiveClicked,
	isLoading,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	rowsPerPageOptions,
	tableScrollHeight,
	showHeaderColumns = false,
	showDeleteIcon = true,
	showArchiveIcon = true,
	selectedResourceSlip,
	selectedResourceSlipList,
	selectedEmployee,
	headerField,
	selectedId,
	tableContainerRef,
}) => {
		// const isInitialRequest = useRef(true);
		// const [loading, setLoading] = useState(false);
		// const theme = useTheme();
		const subMenuVisibility = useSelector(
			(state: IAppState) => state.drawerAction.subMenuVisibility
		);
		const [itemSearch, setItemSearch] = useState("");
		// const [requestParams, setRequestParams] = useState<any>({
		// 	first: initialPage,
		// 	rows: initialPageSize,
		// 	page: initialPage,
		// 	sortField: null,
		// 	sortOrder: "asc",
		// 	searchQuery: "",
		// 	filters: {
		// 		name: { value: "", matchMode: "contains" },
		// 		"country.name": { value: "", matchMode: "contains" },
		// 		company: { value: "", matchMode: "contains" },
		// 		"representative.name": { value: "", matchMode: "contains" },
		// 	},
		// });

		// const ArchiveIcon = () => (
		// 	<svg
		// 		xmlns="http://www.w3.org/2000/svg"
		// 		width="16"
		// 		height="16"
		// 		fill="currentColor"
		// 		viewBox="0 0 16 16"
		// 	>
		// 		<path d="M2.5 1a1 1 0 0 0-1 1v2a1 1 0 0 0 .293.707L3 5.914V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.914l1.207-1.207A1 1 0 0 0 14.5 4V2a1 1 0 0 0-1-1h-11zm1 6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8A.5.5 0 0 1 3.5 7z" />
		// 	</svg>
		// );
		// const slipsDropDownColumnBody = (params: any) => {

		// 	return (
		// 		<>
		// 			{selectedEmployee === params.value ? <Box>
		// 				<Box sx={{ padding: "0.6rem",textAlign:"end" }}>
		// 					<Dropdown
		// 						value={selectedResourceSlip}
		// 						onChange={onResourceSlipSelectionChangeHandler}
		// 						options={selectedResourceSlipList}
		// 						onClick={(e: any) => e.stopPropagation()}
		// 						className="slip-dropdown"
		// 					/>
		// 				</Box>
		// 			</Box> : <></>}
		// 		</>
		// 	);
		// };

		const slipsDropDownColumnBody = useCallback(
			(rowData: any) => {
				const isSelected = selectedEmployee === rowData.value;
				return isSelected ? (
					<Box>
						<Box sx={{ paddingRight: "6px", textAlign: "end" }}>
							<Dropdown
								value={selectedResourceSlip}
								onChange={onResourceSlipSelectionChangeHandler}
								options={selectedResourceSlipList}
								onClick={(e: any) => e.stopPropagation()}
								className="slip-dropdown"
							/>
						</Box>
					</Box>
				) : null;
			},
			[selectedEmployee, selectedResourceSlip, selectedResourceSlipList]
		);

		const renderHeader = () => {
			return (
				<div
					style={{
						display: "flex",
						alignItems: "center",
					}}
				>
					{headerField ? (
						<Grid container columnSpacing={2} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<Grid size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}
								className="p-input-icon-left"
								style={{ display: "flex", height: "40px" }}
							>
								<i className="pi pi-search" />
								<InputText
									value={itemSearch}
									onChange={(e) => setItemSearch(e.target.value)}
									placeholder={"Search..."}
									className="w-full"
									style={{ borderRadius: "2px 2px 2px 2px" }}
								/>
							</Grid>
							<Grid sx={{ "& .dropDownWrapper": { marginBottom: "0!important", marginTop: "0!important" } }} size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>

								{headerField}
							</Grid>
						</Grid>
					) : (
						<span
							className="p-input-icon-left w-full"
							style={{ display: "flex", height: "37px" }}
						>
							<i className="pi pi-search" />
							<InputText
								value={itemSearch}
								onChange={(e) => setItemSearch(e.target.value)}
								placeholder={"Search..."}
								className="w-full"
								style={{ borderRadius: "2px 2px 2px 2px" }}
							/>
						</span>
					)}
				</div>
			);
		};
		const headerSearch = renderHeader();
		function search(_row: any) {
			return (
				rows &&
				rows.filter(
					(rows: any) =>
						rows.label.props.children
							.toLowerCase()
							.indexOf(itemSearch.toLowerCase()) > -1
				)
			);
		}

		// const onPage = (event: any) => {
		// 	// setRequestParams(event);
		// 	setLoading(true);
		// 	//imitate delay of a backend call
		// 	setTimeout(() => {
		// 		setRequestParams({
		// 			...event,
		// 			searchQuery: itemSearch,
		// 		});
		// 		setLoading(false);
		// 	}, 1000);
		// };

		// useEffect(() => {
		// 	// if the results fetcher was passed, we can use it to fetch the results.
		// 	if (onRequestParamsChange) {
		// 		// skip the first initial call
		// 		if (isInitialRequest.current === true) {
		// 		
		// 			isInitialRequest.current = false;
		// 		} else {
		// 			
		// 			onRequestParamsChange(requestParams);
		// 		}
		// 	}
		// }, [onRequestParamsChange, requestParams]);

		// const deepMatchesId = (obj: any, targetId: any): boolean => {
		// 	if (!obj || !targetId) return false;

		// 	// ✅ Skip React elements to avoid infinite recursion
		// 	if (obj?.$$typeof) return false;

		// 	for (const key of Object.keys(obj)) {
		// 		const val = obj[key];

		// 		if (Array.isArray(val)) {
		// 			if (val.some((item) => deepMatchesId(item, targetId))) return true;
		// 		} else if (val && typeof val === "object" && !val?.$$typeof) {
		// 			// ✅ Skip React elements in nested objects too
		// 			if (deepMatchesId(val, targetId)) return true;
		// 		} else if (typeof val === "string") {
		// 			// ✅ Only check string primitives
		// 			if (val === targetId) return true;
		// 		}
		// 	}

		// 	return false;
		// };

		// const getRowClassName = (data: any) => {
		// 	const isMatch = deepMatchesId(data, selectedId);
		// 	return { "p-highlight": isMatch };
		// };

		// const [selectedRow, setSelectedRow] = useState(null);
		// const getRowClassName = (rowData: any) => {
		// 	return rowData === selectedRow ? 'highlighted-row' : '';
		// };
		// useEffect(() => {
		// 	if (!selectedId) {
		// 		setSelectedRow(null)
		// 	}
		// }, [selectedId])

		// 	now i want one loop where i will pass rows and selectedId and i want to filter every object deeply where it end by key and value if any object will have value matched with selectedId in any keye then that main object would be true for isMAtch 
		// and in case of array value of any key then it will rerenders that loop so that make it dynamic and professional

		const deepMatchesId = (obj: any, targetId: any): boolean => {
			if (!obj || !targetId) return false;

			// ✅ Skip React elements to avoid infinite recursion
			if (obj?.$$typeof) return false;

			for (const key of Object.keys(obj)) {
				const val = obj[key];

				if (Array.isArray(val)) {
					if (val.some((item) => deepMatchesId(item, targetId))) return true;
				} else if (val && typeof val === "object" && !val?.$$typeof) {
					// ✅ Skip React elements in nested objects too
					if (deepMatchesId(val, targetId)) return true;
				} else if (typeof val === "string") {
					// ✅ Only check string primitives
					if (val === targetId) return true;
				}
			}

			return false;
		};
		const getRowClassName = (data: any) => {
			const isMatch = deepMatchesId(data, selectedId);
			return { "highlighted-row": isMatch };
		};


		// ##################################      SCROLL ISSUE     #####################################
		// ################## WHEN SCROLL AND CLICK EMPLOYEE THEN SCROLL GOES TO TOP ################################

		const internalRef = useRef<HTMLDivElement>(null);
		const containerRef = (tableContainerRef ?? internalRef) as React.RefObject<HTMLDivElement>;
		const scrollPositionRef = useRef<number>(0);
		const isRestoringRef = useRef<boolean>(false);
		const observerRef = useRef<MutationObserver | null>(null);

		// Track user scroll to always have the latest position saved
		useEffect(() => {
			const getWrapper = () =>
				containerRef.current?.querySelector(".p-datatable-wrapper") as HTMLElement | null;

			const handleScroll = () => {
				// Only update saved position when we are NOT programmatically restoring
				if (!isRestoringRef.current) {
					const wrapper = getWrapper();
					if (wrapper) scrollPositionRef.current = wrapper.scrollTop;
				}
			};

			const wrapper = getWrapper();
			wrapper?.addEventListener("scroll", handleScroll, { passive: true });
			return () => wrapper?.removeEventListener("scroll", handleScroll);
		});

		// MutationObserver: watches for any DOM change inside the table
		// and immediately restores scroll — fires BEFORE browser paint
		useEffect(() => {
			const container = containerRef.current;
			if (!container) return;

			const restoreScroll = () => {
				const wrapper = container.querySelector(
					".p-datatable-wrapper"
				) as HTMLElement | null;
				if (!wrapper || scrollPositionRef.current === 0) return;

				isRestoringRef.current = true;
				wrapper.scrollTop = scrollPositionRef.current;

				// Release the restore lock after browser settles
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						isRestoringRef.current = false;
					});
				});
			};

			observerRef.current?.disconnect();
			observerRef.current = new MutationObserver(restoreScroll);
			observerRef.current.observe(container, {
				childList: true,
				subtree: true,
			});

			return () => observerRef.current?.disconnect();
		}, []); // mount once — observer handles all future DOM changes



		return (
			<div ref={containerRef}
				style={{
					position: "sticky",
					top: subMenuVisibility ? "170px" : "128px",
					maxHeight: `calc(100vh - ${subMenuVisibility ? "170px" : "128px"})`,
				}}
			>
				<DataTable
					value={rows && search(rows)}
					key={`${selectedEmployee}-${selectedResourceSlip}-${selectedResourceSlipList?.length ?? 0
						}`}
					// responsiveLayout="scroll"
					// lazy
					// paginator
					// first={requestParams.first}
					// rows={requestParams.rows}
					// totalRecords={totalRecords}
					// onPage={onPage}
					// rowsPerPageOptions={rowsPerPageOptions}
					// paginatorTemplate=" PrevPageLink PageLinks NextPageLink  CurrentPageReport RowsPerPageDropdown"
					// currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
					scrollable
					scrollHeight={tableScrollHeight ? tableScrollHeight : "75vh"}
					loading={isLoading}
					header={headerSearch}
					emptyMessage="No Record found."
					className={`${showHeaderColumns
						? "ResourceDDLDataTableForSlipsWithHeaderColumns"
						: "ResourceDDLDataTableForSlips"
						}`}
					// style={{
					// 	position: "sticky",
					// 	top: subMenuVisibility ? "170px" : "128px",
					// }}
					// onRowClick={(e: any) => setSelectedRow(e.data)}
					rowClassName={getRowClassName}
				>
					{/* <Column field={"label"} />
				<Column body={slipsDropDownColumnBody}></Column> */}
					{columns &&
						columns.map((x: any, index: any) => (
							<Column key={index} field={x.field} header={x.headerName} />
						))}
					{/* {!columns && <Column field={"label"} />} */}

					{!columns && (
						<Column
							field={"label"}
							body={(rowData) => {
								const text = rowData.label?.props?.children ?? rowData.label ?? "";
								return (
									<span title={String(text)}>
										{rowData.label}
									</span>
								);
							}}
						/>
					)}
					<Column
						body={slipsDropDownColumnBody}
					// style={{
					// 	width:
					// 		showDeleteIcon && showArchiveIcon
					// 			? "5.6em"
					// 			: showDeleteIcon || showArchiveIcon
					// 			? "2.8em"
					// 			: "0",
					// }}
					/>
				</DataTable>
			</div>
		);
	};
